<!-- Translated: yes -->
<template>
  <div class="relative">
    <Back :clicked="goBack" />
    <!-- <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="startup" /> -->

    <div v-if="!SITE_CONFIG.modules_open.skiletting.open" class="rental-closed">
      <p>{{ SITE_CONFIG.modules_open.skiletting.closed_message }}</p>
    </div>

    <div v-if="SITE_CONFIG.modules_open.skiletting.open">
    <div class="remove-user" @click="remove(index)" v-if="parseInt($route.params.person)">{{ $t('skirental.remove-title', {skier: ''}) }} <button class="white small border"><icon name="trash" :scale="1.4" /></button></div>

    <div :class="'component ' + (allProducts.length >=3 ? 'wider' : '')">
      <Timeline :steps="timelineSteps"></Timeline>
      <OnSiteFooter v-if="$store.state.isOnSite" />

      <h1>{{ $t('skirental.pick-products', {skier: ''}) }} {{person.name}}</h1>

      <div class="blue-bar">
        <b v-if="selectedType === 'package'">{{ $t('skirental.package', {package: ''}) }} {{categories[selectedCategory]}}:</b>
        <b v-if="selectedType === 'single'">{{categories[selectedCategory]}}:</b>
        <b v-if="person.type !== 'single' && person.type !== 'package'">
          <b v-if="person.onlySkipass">{{ $t('general.skipass') }}:</b>
        </b>
        {{ages[person.age]}}
        <span v-if="selectedLevel === 'beginner'"><b>{{ $t('general.level') }}:</b> {{ $t('general.levels.beginner') }}</span>
        <span v-if="selectedLevel === 'intermediate'"><b>{{ $t('general.level') }}:</b> {{ $t('general.levels.average') }}</span>
        <span v-if="selectedLevel === 'advanced'"><b>{{ $t('general.level') }}:</b> {{ $t('general.levels.advanced') }}</span>
      </div>

      <div class="center">
        <div class="info" v-if="$route.query['from-single']">
          Du tittar nu på våra paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du gå tillbaka till <a href="#" @click.stop.prevent="goToSingle()">våra enstaka produkter</a> istället?
        </div>
      </div>

      <Loading :show="loading" />

      <div :class="{flex: true, disabled: loading}">
        <div :title="($store.state.isDebugging) ? item.pool_lid : ''" :class="{box: true, active: (selectedProducts.indexOf(item) !== -1)}" v-for="item in allProducts" @click="setActive(item)">
          <div class="image default-image" :style="item.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + item.image + ')' : 'background-size:cover;'">
          </div>

          <b>{{item.name}}</b>
          <p class="smalltext" v-if="item.smalltext">{{item.smalltext}}</p>
          <p class="subtitle" v-if="item.subtitle">{{item.subtitle}}</p>
          <p>
            <span v-if="!item.buy">{{(person.priceType === 'night' && SITE_CONFIG.site !== 'vallasen') ? '' : person.days}} {{
              (person.priceType === 'night' ?
                (SITE_CONFIG.site === 'vallasen' ? $t('general.night') : $t('skirental.day-options.hours', { hours: SITE_CONFIG.rental.night_hours })) :
                (person.days > 1 ? $t('general.days') : $t('general.day'))
              )
            }}</span> <span v-if="item.buy">{{ $t('general.buy') }}</span>
            <b>{{item['price_' + person.days + (person.priceType === 'night' ? '_night' : '')] | currency}}</b> 
            <span class="original-price" v-if="item['price_' + person.days + (person.priceType === 'night' ? '_night' : '')] !== item['price_' + 'original_' + person.days + (person.priceType === 'night' ? '_night' : '')]">{{item['price_' + 'original_' + person.days + (person.priceType === 'night' ? '_night' : '')] | currency}}</span>
            </p>

          <div>
            <!-- Info -->
            <button class="float-left outline-button" @click.stop="infoPopup(item)" v-if="item.description"><icon name="info-blue" :scale="1.4" /> {{ $t('general.info-short') }}</button>
            <!-- Pick button -->
            <button :class="{small: true, green: (selectedProducts.indexOf(item) !== -1), 'float-right': true}">
              {{selectedProducts.indexOf(item) !== -1 ? $t('general.picked') : $t('general.pick')}}
            </button>
            <!-- Trash -->
            <button :class="'small trash border float-right'" v-if="(selectedProducts.indexOf(item) !== -1)"><icon name="trash" :scale="1.3" /></button>
          </div>
        </div>
      </div>

      <div class="center">
        <div class="info" v-if="showPackageInfo">
          Du har valt produkter som ingår i paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du kolla på <a href="#" @click.stop.prevent="goToPackages()">våra paket</a> istället?
        </div>
      </div>

      <div class="center space-3">
        <button @click="next()" :disabled="selectedProducts.length === 0 ? true : false">{{ $t('general.go-on') }}</button>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import moment from 'moment';

import API from '@/classes/API';
import Timeline from '@/components/components/Timeline';
import OnSiteFooter from '@/components/components/OnSiteFooter';
import Loading from '@/components/components/Loading';

import Back from '@/components/components/Back';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import rentalTimelineSteps from '@/mixins/rentalTimelineSteps';

export default {
  data() {
    return {
      allProducts: [],
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
        seniors: 'Senior',
      },
      selectedAge: null,
      selectedCategory: null,
      selectedSubCategory: null,
      selectedType: null,
      selectedPackage: null,
      selectedProducts: [],
      selectedProductsBackup: [],
      selectedLevel: null,
      categories: {},
      showPackageInfo: false,
      loading: false,
    };
  },
  mixins: [rentalTimelineSteps],
  components: {
    Timeline,
    OnSiteFooter,
    Back,
    LanguageSwitcher,
    Loading,
  },
  async mounted() {
    this.ages = {
      children: this.$i18n.t('general.ages.child'),
      youths: this.$i18n.t('general.ages.youth'),
      adults: this.$i18n.t('general.ages.adult'),
      seniors: this.$i18n.t('general.ages.senior'),
    };

    this.startup();
  },
  computed: {
  },
  watch: {
    $route() {
      this.startup();
    },
  },
  methods: {
    async startup() {
      this.loading = true;
      this.person = this.$store.state.cart.rentals[this.$route.params.person];
      const days = this.person.days;

      this.selectedAge = this.$route.query.age;
      this.selectedCategory = this.$route.query.category;
      this.selectedSubCategory = this.$route.query.category2;
      this.selectedType = this.$route.query.type;
      this.selectedPackage = this.$route.query.package;
      this.selectedLevel = this.$route.query.level;

      let date = '';
      if (this.person.startDate) {
        date = moment(this.person.startDate).format('YYYY-MM-DD');
      }

      const { data, meta, buy } = await API.get(`/skiletting/search?age=${this.selectedAge}&type=${this.selectedType}&level=${this.selectedLevel}&category=${this.selectedCategory}&date=${date}&days=${days}`);
      this.allProducts = data;
      this.categories = meta.categories_all;

      buy.forEach((product) => {
        product.buy = true; // eslint-disable-line
        this.allProducts.push(product);
      });

      this.loading = false;
    },
    ...mapMutations([
      'openModal',
      'addProducts',
      'closeModal',
    ]),
    infoPopup(item) {
      let suffix = '';

      this.openModal(['GeneralModal', {
        title: item.name,
        content: item.description,
      }]);

      suffix = (this.person.priceType === 'night' ? '_night' : '');

      window.trackViewItem({
        title: 'Skidhyra',
        lines: [{
          id: item.pool_lid,
          title: item.code,
          category: 'equipment',
          quantity: 1,
          price: item[`price_${this.person.days}${suffix}`],
        }],
      });
    },
    async setActive(item) {
      const index = this.selectedProducts.indexOf(item);
      if (index !== -1) {
        this.selectedProducts.splice(index, 1);
      } else {
        let suffix = '';

        this.selectedProducts.push(item);

        suffix = (this.person.priceType === 'night' ? '_night' : '');

        window.trackViewItem({
          title: 'Skidhyra',
          lines: [{
            id: item.pool_lid,
            title: item.code,
            category: 'equipment',
            quantity: 1,
            price: item[`price_${this.person.days}${suffix}`],
          }],
        });
      }

      const data = await API.frontendHelper(`skirental/check-for-package?age=${this.selectedAge}`, this.selectedProducts);
      this.showPackageInfo = data.package;
    },
    goToPackages() {
      this.$router.push({
        path: `/skidhyra/${this.$route.params.person}/produkter`,
        query: {
          age: this.$route.query.age,
          category: this.$route.query.category,
          category2: this.$route.query.category2,
          type: 'package',
          package: this.$route.query.package,
          level: this.$route.query.level,
          'from-single': 1,
        },
      });

      this.selectedProducts = [];
      this.showPackageInfo = false;
    },
    goToSingle() {
      this.$router.push({
        path: `/skidhyra/${this.$route.params.person}/produkter`,
        query: {
          age: this.$route.query.age,
          category: this.$route.query.category,
          category2: this.$route.query.category2,
          type: 'single',
          package: this.$route.query.package,
          level: this.$route.query.level,
        },
      });

      this.selectedProducts = [];
      this.showPackageInfo = true;
    },
    pickedProducts() {
      if (this.typeObject && this.typeObject.data) {
        return this.typeObject.data.filter(item => item.picked);
      }
      return [];
    },
    next() {
      const products = [];
      this.allProducts.forEach((item) => {
        const index = this.selectedProducts.indexOf(item);
        const product = item;
        if (index !== -1) {
          product.price = product.prices[this.person.days + (this.person.priceType === 'night' ? '_night' : '')].normal;
          product.price_insurance = product.prices[this.person.days + (this.person.priceType === 'night' ? '_night' : '')].with_insurance;
          products.push(product);
        }
      });

      this.addProducts({
        index: this.$route.params.person,
        products,
      });
      this.$router.push({ name: 'ski rental overview' });
    },
    remove() {
      const $this = this;
      const index = $this.$route.params.person;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.person.name }),
        buttons: [
          {
            title: this.$i18n.t('general.yes'),
            class: 'small',
            click: () => {
              $this.$store.state.cart.rentals.splice(index, 1);
              $this.closeModal();
              $this.$router.push({ name: 'ski rental overview' });
            },
          },
          {
            title: this.$i18n.t('general.no'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    goBack() {
      this.$router.push(`/skidhyra/${this.$route.params.person}`);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.info
  info-box()
  display: inline-block;
  width auto
  margin 20px auto
  font-size 16px
  padding 1em 2em

.component
  +max-mobile()
    padding-top: 5px

.outline-button
  border-radius 4px
  background-color #ffffff
  border solid 1px light-blue-grey
  font-family Interstate
  font-size 11px
  font-weight bold
  color deep-sea-blue
  text-transform uppercase
  text-decoration none
  padding 5px 8px
  display inline-block
  &:hover
    border solid 1px light-blue-grey
    background-color: light-blue-grey
    color #005580

.component
  max-width 620px
  margin 0 auto
  &.wider
    max-width 930px

.blue-bar
  width 100%
  border-radius 2px
  background-color #005580
  padding 6px 14px
  color white
  text-transform uppercase
  font-size 11px
  span
    display: inline-block;
    margin-left: 20px

h1
  text-transform none
  font-size 26px

.flex
  display flex
  justify-content center
  margin-top 20px
  flex-wrap wrap

  .box
    border-radius 2px
    background-color #ffffff
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.17);
    margin-right 18px
    margin-left 18px
    margin-bottom 18px
    padding: 5px 5px 15px;
    width 274px
    max-width 100%
    text-align center
    border 3px solid white
    cursor pointer
    .subtitle
      display: inline-block;
      margin-bottom: 2px
      background-color: rgba(236,245,248,0.5);
      border-radius: 2px
      border: solid 1px #bfd9e1
      padding: 3px 6px
      text-transform: uppercase
      font-size: 9px
      font-weight: bold
      color: deep-sea-blue
    .smalltext
      margin-top 0
      margin-bottom 0
    +max-mobile()
      width 100%
      margin-left padding-mobile
      margin-right padding-mobile
      text-align: left
      padding-top 7px
      padding-bottom 7px
    &.active
      border-color #c7dcb7
      background-image url('https://static.booking.branasgruppen.se/static/svg/green-check.svg')
      background-position: 98% 2%;
      background-size: 24px 24px;
      background-repeat: no-repeat;
      box-shadow: 0 0 10px 0 #c7dcb7;
    .image
      height 175px
      border-radius 2px
      background-color rgba(225, 239, 243, 0.3)
      background-size 75%
      background-repeat no-repeat
      background-position center center
      image-rendering: -webkit-optimize-contrast;
      margin-bottom: 8px
      +max-mobile()
        height 123px
        width 123px
        background-size 95%
        float left
        margin-right 10px
        margin-bottom: 0px
        background-position: center
    b
      text-transform uppercase
      display block
      font-size 12px
      margin-top: 2px
    p
      font-size 12px
      margin-top 5px
      b
        display inline
        margin-top 0
    & > div
      button
        margin-left 3px
        margin-right 3px

.space-3
  margin space-3
  +max-mobile()
    margin-top: 7px

.relative
  position: relative
.remove-user
  position absolute
  right 50px
  top 20px
  color white
  font-size 9px
  letter-spacing 0.5px
  text-align right
  color deep-blue
  uppercase()
  button
    margin-left 5px
  +max-tablet()
    position fixed
    left auto
    width auto
    text-align: center;
    margin-top 0px
    right: 10px;
    bottom: 2%;
    top: auto;
    z-index: 9999


.go-back
  display none

.language-switcher
  position absolute
  right 10px
  top 5px
  width: auto
  display inline-block
  padding: 5px 10px;

+max-mobile()
  hr
    display none
  .language-switcher
    top 3px
  .go-back
    display inline-block
    background-color: pale-grey
    padding: 14px 15px 12px;
    color deep-sea-blue
    position absolute
    top 0
    left 0
    font-weight bold
    width: 100%
    font-size: 12px;
    uppercase()
    .icon
      position: relative
      top: -1px
      margin-right: 7px

.original-price
  text-decoration line-through
  color #999

.rental-closed
  text-align center
  margin 4em auto
  max-width 650px
  font-size 16px
  line-height 1.5
  padding 0 20px
</style>



// WEBPACK FOOTER //
// SkiRentalUserProducts.vue?4a1341f0